var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"view-page-console"},[_c('h1',[_vm._v("Debug "+_vm._s(_vm.title))]),_vm._v(" "),_c('tabs',{attrs:{"links":_vm.tabs}}),_vm._v(" "),_c('fade',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e33f78","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageConsole.vue
// module id = 341
// module chunks = 0